import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { UserContext } from '../App'
import { getEntryById } from './registry'
import { getEntryAccess } from './visibility'
import { useNavContext } from './useNavigation'

// Honours uiPreferences.defaultLandingPage (a registry entry id, set in My
// Account): the first visit to "/" each browser session redirects there.
// Later visits to "/" show the dashboard as normal - the preference changes
// where you land after login, it doesn't hide Home.
const SESSION_FLAG = 'ambunet:landingRedirectDone'

const RootRedirect = ({ children }) => {
  const { user } = useContext(UserContext)
  const ctx = useNavContext()

  const preferenceId = user?.uiPreferences?.defaultLandingPage
  const entry = preferenceId ? getEntryById(preferenceId) : null

  let alreadyDone = true
  try {
    alreadyDone = sessionStorage.getItem(SESSION_FLAG) === 'true'
    if (!alreadyDone) sessionStorage.setItem(SESSION_FLAG, 'true')
  } catch {
    // Blocked storage: never redirect rather than redirect on every visit
  }

  if (
    !alreadyDone &&
    entry &&
    entry.path !== '/' &&
    getEntryAccess(entry, ctx) === 'visible'
  ) {
    return <Navigate to={entry.path} replace />
  }

  return children
}

export default RootRedirect
